export enum GtmCustomEventNameEnum {
  GeoLocating = 'geo_locating',
  QuickFilters = 'quick_filters',
  StoreView = 'store_view',
  FilterUsage = 'filter_usage',
  FindStationSearchbar = 'find_station_searchbar',
  GetDirection = 'get_direction',
  Go2StoreInfo = 'go2_store_info',
  MapPinMain = 'map_pin_main',
  DropFilterGroup = 'drop_filter_group',
  FilterGroup = 'filter_group',
  BackButton = 'back_button',
  HoursDrop = 'hours_drop',
  MapViewMobile = 'map_view_mobile',
  ServiceTabs = 'service_tabs',
  ServiceLink = 'service_link',
  MapPinStore = 'map_pin_store',
}
